import React, { useEffect, useState } from "react";
import Layouts from "../../Layouts";
import sun from "../../../Assets/Icons/sun.svg";
import person from "../../../Assets/Icons/person.svg";
import line from "../../../Assets/Icons/line.svg";
import image from "../../../Assets/Images/Svg/dashboardBaner.png";
import edit from "../../../Assets/Icons/edit1.svg";
import appoint from "../../../Assets/Icons/totalappoint.svg";
import wave from "../../../Assets/Icons/ic-trending-up-24px.svg";
import wave1 from "../../../Assets/Icons/downarw.svg";
import earning from "../../../Assets/Icons/totalearnings.svg";
import patient from "../../../Assets/Icons/totalpatient.svg";
import { Stethoscope, Bed, Wallet } from "lucide-react";
import Appointments from "./Appointments";
import dash from "../../../Assets/Icons/grid.svg";
import table from "../../../Assets/Icons/table.svg";
import calen from "../../../Assets/Icons/calendar1.svg";
import cardEnable from "../../../Assets/Images/Svg/CardEnable.svg";
import tableEnable from "../../../Assets/Images/Svg/tableEnabled.svg";
import calenEnable from "../../../Assets/Images/Svg/calendarEnabled.svg";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import PatientService from "../../../Services/PatientService";
import DashboardService from "../../../Services/DashboardService";
import AppointmentService from "../../../Services/AppointmentService";
import dayjs from "dayjs";
import { message, Spin } from "antd";
import DoctorService from "../../../Services/DoctorService";
import { useForm } from "antd/es/form/Form";
import InviteCard from "../Dashboard/InviteCard";
import NewInviteCard from "./NewInviteCard";
import HimsModuleCards from "./HimsModuleCards";
import AppointmentCalender from "../UpcomingAppointments/AppointmentCalender";
import AppointmentCard from "../UpcomingAppointments/AppointmentCard";
import PatientQueue from "../VCPage/PatientQueue";
import { MdKeyboardDoubleArrowUp } from "react-icons/md";
import { IoIosCloseCircle } from "react-icons/io";
import Draggable from "react-draggable";
import patientqueue from "../../../Assets/Images/Svg/queue2.svg";
import { useHistory } from "react-router-dom";
import { APP_ROUTES } from "../../../PageRouting/approutes";
import { getLoaderState } from "../../../Redux/actions/CommonActions";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserWalletDetails } from "../../../Redux/actions/UserActions";

function NewDashboard() {
  const [activeTab, setActiveTab] = useState("1");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const { walletDetails, walletAmount } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    sessionStorage.removeItem("rpmPatient");
    sessionStorage.removeItem("patient");

    const payload = {
      userId: loginResultObject?.user?.userId,
      account_Id: loginResultObject?.user?.account_Id,
      clinic_Id: loginResultObject?.user?.clinic_Id,
    };
    dispatch(fetchUserWalletDetails(payload));
  }, []);

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      appointmentsList(page);
    }
  };

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [patientsInviteList, setPatientsInviteList] = useState([]);
  const [counts, setCounts] = useState({});
  const [upcomingList, setUpcomingList] = useState([]);

  const storedLoginResult = sessionStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;

  const appointmentsList = (pageNo = 1, pageSize = 5) => {
    const fromDate = new Date();
    const formattedDate = fromDate.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });

    let payload = {
      userId: loginResultObject.user.userId,
      clinic_Id: loginResultObject.user.clinic_Id,
      fromDate: formattedDate,
      pageNo: pageNo,
      pageSize: pageSize,
    };

    AppointmentService.AppointmentFilter(payload)
      .then((result) => {
        setPatientsInviteList(result.data);
        getCount();
        if (result.data.length === pageSize) {
          setTotalPages(pageNo + 1);
        } else {
          setTotalPages(pageNo);
        }
        setCurrentPage(pageNo);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    appointmentsList();
    getCount();
  }, []);

  const getCount = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const firstDate = new Date(year, month, 1);
    const lastDate = new Date(year, month + 1, 0);

    const formatDate = (date) => {
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const year = date.getFullYear();
      return `${month}/${day}/${year}`;
    };

    let payload = {
      account_Id: loginResultObject.user.account_Id,
      clinic_Id: loginResultObject.user.clinic_Id,
      userId: loginResultObject.user.userId,
      billingStatus: 1,
      fromDate: formatDate(firstDate),
      toDate: formatDate(lastDate),
    };

    DashboardService.DashboardCounts(payload).then((res) => {
      setCounts(res.data);
    });
  };

  const history = useHistory();

  const onClose = () => {
    setIsDrawerOpen(false);
  };
  const showDrawer = () => {
    setIsDrawerOpen(true);
  };

  const [isVerticalOpen, setIsVerticalOpen] = useState(true);
  const handleClick = () => {
    setIsVerticalOpen(true);
  };
  const closeCircle = () => {
    setIsVerticalOpen(false);
  };

  const formatEarnings = (val, fallback) => {
    if (val === undefined || val === null || val === "") return fallback;
    if (typeof val === "number") return val.toLocaleString();
    return val;
  };

  return (
    <Layouts>
      {/* ─── MOBILE RESPONSIVE STYLES (scoped) ─── */}
      <style>{`
        @media (max-width: 640px) {
          /* Toolbar: stack title row and icons row vertically */
          .appt-toolbar {
            flex-direction: column !important;
            align-items: flex-start !important;
            gap: 8px !important;
            padding: 10px !important;
          }
 
          /* Title button: don't overflow, allow wrap */
          .appt-toolbar-title button {
            white-space: nowrap !important;
            font-size: 13px !important;
            padding: 4px 10px !important;
          }
 
          /* Icons row: keep in a row, align right */
          .appt-toolbar-icons {
            display: flex !important;
            flex-direction: row !important;
            align-items: center !important;
            gap: 8px !important;
            width: 100% !important;
            justify-content: flex-end !important;
          }
 
          /* View All button: shrink text slightly */
          .appt-toolbar-icons .view-all-btn {
            font-size: 12px !important;
            padding: 4px 8px !important;
            width: auto !important;
          }
        }
      `}</style>

      <div>
        <div className="relative flex md:flex-row flex-col gap-2 w-full">
          {/* Greeting Banner */}
          <div className="w-full md:w-[46%] lg:w-[40%] bg-gradient-to-r from-[#189FAA] to-[#4789C0] border h-[170px] p-4 rounded-md relative overflow-hidden">
            <div className="relative z-10 w-full">
              <div className="flex gap-2 items-center">
                <img src={sun} alt="" className="w-6 h-6" />
                <h3 className="text-white font-medium font-sans text-sm mt-1">
                  Hi,
                </h3>
              </div>

              <div className="mt-1">
                <h3 className="text-[#DDFF00] text-sm font-sans font-bold leading-snug">
                  {` ${loginResultObject.user.salutation} ${loginResultObject.user.firstName} ${loginResultObject.user.lastName} `}
                  <span className="text-white text-sm font-sans">
                    {`${loginResultObject.user.qualification} `}
                  </span>
                </h3>
                <h3 className="text-sm font-sans font-medium text-white truncate">
                  {loginResultObject.user.speciality}
                </h3>
              </div>

              <NewInviteCard appointmentsList={appointmentsList} />
            </div>
          </div>

          {/* Doctor Image */}
          {/* Doctor Image - wider + pulled closer to banner */}
          <div className="hidden md:block w-[280px] lg:w-[340px] xl:w-[400px] h-[170px] rounded-md overflow-hidden -ml-10 lg:-ml-14">
            <img
              src={image}
              alt="doctor consultation"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Stat Cards */}
          <div className="flex flex-col md:flex-row gap-3 flex-1 ml-2">
            <div
              className={`min-w-0 h-[170px] rounded-md shadow-md border p-3 ${
                loginResultObject?.user?.himsApplicable === "Y"
                  ? "md:flex-[0.75] flex-1"
                  : "flex-1"
              }`}
            >
              <div className="w-8 h-8 bg-[#FDB8C7] rounded-md flex items-center justify-center">
                <img src={appoint} alt="" className="w-4 h-4" />
              </div>
              <p className="text-xs font-sans font-medium text-[#333333] mt-2 truncate">
                Total Appointments
              </p>
              <p className="text-base font-sans font-bold text-[#333333]">
                {counts.Total_Appointment_Count}
              </p>
            </div>

            <div
              className={`min-w-0 h-[170px] rounded-md shadow-md border p-3 ${
                loginResultObject?.user?.himsApplicable === "Y"
                  ? "md:flex-[0.75] flex-1"
                  : "flex-1"
              }`}
            >
              <div className="w-8 h-8 bg-[#CDF4FF] rounded-md flex items-center justify-center">
                <img src={patient} alt="" className="w-4 h-4" />
              </div>
              <p className="text-xs font-sans font-medium text-[#333333] mt-2 truncate">
                New Patients
              </p>
              <p className="text-base font-sans font-bold text-[#333333]">
                {counts.Total_Patient_Count}
              </p>
            </div>

            {loginResultObject?.user?.himsApplicable === "Y" ? (
              <div className="md:flex-[1.5] flex-1 min-w-0 h-[170px] rounded-md shadow-md border bg-white p-3 flex flex-col justify-between">
                {/* Top Section: Icon + Total Earnings */}
                <div>
                  <div className="w-8 h-8 bg-[#CDFFD8] rounded-md flex items-center justify-center text-[#16A34A]">
                    <Wallet className="w-4 h-4" />
                  </div>
                  <p className="text-xs font-sans font-medium text-[#333333] mt-2 truncate">
                    Total Earnings
                  </p>
                </div>

                <div className="bg-gray-50 border border-gray-200/70 rounded-lg p-2 flex items-center justify-between gap-2">
                  {/* OPD */}
                  <div className="flex items-center gap-2 flex-1 min-w-0">
                    <div className="w-7 h-7 rounded-full bg-[#E0F7FA] flex items-center justify-center flex-shrink-0 text-[#00897B]">
                      <Stethoscope className="w-3.5 h-3.5" />
                    </div>
                    <div className="min-w-0">
                      <p className="text-[11px] font-sans font-medium text-gray-500 truncate leading-none">
                        OPD
                      </p>
                      <p className="text-xs md:text-sm font-sans font-bold text-[#333333] leading-none mt-1">
                        {formatEarnings(
                          counts?.opdEarnings ??
                            counts?.OPD_Earnings_Count ??
                            counts?.opd_earnings,
                          "14,250",
                        )}
                      </p>
                    </div>
                  </div>

                  {/* Divider */}
                  <div className="w-[1px] h-6 bg-gray-300 mx-1 flex-shrink-0" />

                  {/* IPD */}
                  <div className="flex items-center gap-2 flex-1 min-w-0">
                    <div className="w-7 h-7 rounded-full bg-[#E0F2FE] flex items-center justify-center flex-shrink-0 text-[#0284C7]">
                      <Bed className="w-3.5 h-3.5" />
                    </div>
                    <div className="min-w-0">
                      <p className="text-[11px] font-sans font-medium text-gray-500 truncate leading-none">
                        IPD
                      </p>
                      <p className="text-xs md:text-sm font-sans font-bold text-[#333333] leading-none mt-1">
                        {formatEarnings(
                          counts?.ipdEarnings ??
                            counts?.IPD_Earnings_Count ??
                            counts?.ipd_earnings,
                          "7,400",
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="flex-1 min-w-0 h-[170px] rounded-md shadow-md border p-3">
                <div className="w-8 h-8 bg-[#CDFFD8] rounded-md flex items-center justify-center">
                  <img src={earning} alt="" className="w-4 h-4" />
                </div>
                <p className="text-xs font-sans font-medium text-[#333333] mt-2 truncate">
                  Total Earnings
                </p>
                <p className="text-base font-sans font-bold text-[#333333]">
                  {counts.Total_Earnings_Count}
                </p>
              </div>
            )}
          </div>
        </div>

        {/* ── HIMS IPD Module Cards (visible only when himsApplicable === "Y") ── */}
        {loginResultObject?.user?.himsApplicable === "Y" && (
          <HimsModuleCards counts={counts} />
        )}

        <div className="border rounded-md mt-5">
          {/* ── Toolbar header — mobile: stacks into 2 rows ── */}
          <div className="appt-toolbar flex justify-between p-3">
            {/* Left: title */}
            <div className="appt-toolbar-title flex gap-2">
              <button
                className={`px-4 py-1 rounded-full font-semibold font-sans bg-[#DEF3F2]`}
                onClick={() => setActiveTab("1")}
              >
                {activeTab === "1" && `Today's Appointments`}
                {activeTab === "3" && `Today's Appointments`}
                {activeTab === "4" && `Calender View`}
              </button>
            </div>

            {/* Right: icon buttons + View All */}
            <div className="appt-toolbar-icons flex gap-3">
              <div
                onClick={() => setActiveTab("1")}
                className="w-8 h-8 border rounded-md flex justify-center items-center cursor-pointer"
              >
                {activeTab === "1" ? (
                  <img src={tableEnable} alt="" className="w-5 h-5" />
                ) : (
                  <img src={table} alt="" className="w-5 h-5" />
                )}
              </div>
              <div
                onClick={() => setActiveTab("3")}
                className="w-8 h-8 border rounded-md flex justify-center items-center cursor-pointer"
              >
                {activeTab === "3" ? (
                  <img src={cardEnable} alt="" className="w-5 h-5" />
                ) : (
                  <img src={dash} alt="" className="w-5 h-5" />
                )}
              </div>
              <div
                onClick={() => history.push(APP_ROUTES.APPTCALENDAR)}
                className="w-8 h-8 border rounded-md flex justify-center items-center cursor-pointer"
              >
                {activeTab === "4" ? (
                  <img src={calenEnable} alt="" className="w-5 h-5" />
                ) : (
                  <img src={calen} alt="" className="w-5 h-5" />
                )}
              </div>
              <div
                onClick={() => history.push(APP_ROUTES.APPOINTMENTS)}
                className="view-all-btn w-24 px-2 py-1 border rounded-md font-bold font-sans text-sm flex justify-center items-center cursor-pointer"
              >
                View All
              </div>
            </div>
          </div>

          <div className="rounded-b-md">
            {activeTab === "1" && (
              <>
                {loading ? (
                  <div className="flex justify-center items-center mt-40">
                    <Spin />
                  </div>
                ) : (
                  <Appointments
                    appointmentsList={appointmentsList}
                    patientsInviteList={patientsInviteList}
                    setPatientsInviteList={setPatientsInviteList}
                    activeTab={activeTab}
                  />
                )}
                <div className="h-[49px] w-full border rounded-md flex justify-end items-center p-5">
                  <div className="flex items-center justify-center space-x-2">
                    <button
                      className={`p-2 rounded-md ${
                        currentPage === 1
                          ? "text-gray-400 cursor-not-allowed bg-white"
                          : "text-gray-700 bg-white"
                      }`}
                      onClick={() => goToPage(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      <FaChevronLeft className="text-[#189FAA]" />
                    </button>

                    {[...Array(totalPages)].map((_, index) => {
                      const page = index + 1;
                      return (
                        <button
                          key={page}
                          className={`px-3 py-1 rounded-md ${
                            currentPage === page
                              ? "bg-teal-500 text-white text-sm"
                              : "text-gray-700 text-sm hover:bg-gray-200 bg-white border rounded-md"
                          }`}
                          onClick={() => goToPage(page)}
                        >
                          {page}
                        </button>
                      );
                    })}

                    <button
                      className={`p-2 rounded-md ${
                        currentPage === totalPages
                          ? "text-gray-400 cursor-not-allowed bg-white"
                          : "text-gray-700 bg-white"
                      }`}
                      onClick={() => goToPage(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      <FaChevronRight className="text-[#189FAA]" />
                    </button>
                  </div>
                </div>
              </>
            )}

            {activeTab === "3" && <AppointmentCard />}
            {activeTab === "4" && <AppointmentCalender />}
          </div>
        </div>
      </div>

      {/* patient queue design — unchanged */}
      {isVerticalOpen ? (
        <Draggable>
          <div className="draggable-container fixed top-1/2 right-2 w-14 transform -translate-y-1/2 z-50">
            <div
              className="hidden md:block relative mb-5 cursor-pointer"
              onClick={closeCircle}
            >
              <IoIosCloseCircle className="hidden md:block text-red-400 absolute mb-1 right-0 top-0" />
            </div>
            <img
              src={patientqueue}
              alt="patientqueue"
              className="cursor-pointer"
              title="Patient Queue"
              onClick={showDrawer}
              onTouchEnd={showDrawer}
            />
          </div>
        </Draggable>
      ) : (
        <div
          className="vertical"
          style={{ marginTop: "16rem" }}
          onClick={handleClick}
        >
          <p className="vertical-p">
            <div className="vertical-icon-dashboard">
              <MdKeyboardDoubleArrowUp />
            </div>
            Queue
          </p>
        </div>
      )}

      {isDrawerOpen && <PatientQueue onClose={onClose} />}
    </Layouts>
  );
}

export default NewDashboard;
